<template>
  <v-footer class="pa-4" v-if="isAuthenticated">
    <v-spacer></v-spacer>
    <div>
      &copy; Clac des Doigts {{ new Date().getFullYear() }} - v.{{ appVersion }} -
      <v-chip>{{ projectId }}</v-chip>on
      <v-chip>{{ projectEnv }}</v-chip>
    </div>
    <v-spacer></v-spacer>
  </v-footer>
</template>

<script>
import { mapState } from "vuex";
import { version } from "../../package.json";
console.log("Appversion", version);

export default {
  name: "AppNavigation",
  data() {
    return {
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      projectEnv: process.env.NODE_ENV
    };
  },
  computed: {
    ...mapState(["isAuthenticated", "profile"]),
    appVersion() {
      return version;
    }
  },
  methods: {},
  mounted: function() {},
  watch: {}
};
</script>
